import { CustomizationDerivedTargetMap } from 'data/customization/customization.types';

// eslint-disable-next-line import/prefer-default-export
export function getTargetActualPrimaryType(
  targetTag: string,
  derivedTargets: CustomizationDerivedTargetMap,
  services: string[],
): string {
  let actualPrimaryType = targetTag;
  const derivedTarget = derivedTargets[targetTag];
  if (!derivedTarget) {
    return actualPrimaryType;
  }
  // the target name should not varies based on services
  services.some((service) => {
    if (derivedTarget[service]?.target) {
      actualPrimaryType = derivedTarget[service].target ?? targetTag;
      return true;
    }
    return false;
  });

  return actualPrimaryType;
}
